module.exports = __webpack_public_path__ + "img/28.65e7397b.png";